import store from './createStore';

export default store;
